import React from "react";
import "../../styles/OffersSection/OffersCard.scss";
export interface Offer {
  id: number;
  name: string;

  description: string;
}
export const OfferCard: React.FC<{
  index: number;
  title: string;
  description: string;
}> = ({ title, description, index }) => {
  return (
    <div className="Offer">
      <div className="offer-image-container">
        <img
          className="offer-image"
          src={`/images/offer${index}.jpeg`}
          alt={title}
          loading="lazy"
        />
      </div>
      <div className="offer-content">
        <h2>{title}</h2>
        <h1>{description}</h1>
      </div>
    </div>
  );
};
